import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import FocusableHeader from 'components/focusableheader/FocusableHeader';

import useAccounts from '../../context/useAccounts';
import TransitionSlideIn from '../animations/TransitionSlideIn';
import DigitalBarcode from '../digitalBarcode/DigitalBarcode';
import DigitalCardCarousel from '../digitalCard/DigitalCardCarousel';

import AccountSummary from './AccountSummary';
import AccountSuspendedNotice from './AccountSuspendedNotice';

const Account = () => {
    const { accounts, activeAccount, activeAccountIndex, setActiveAccountIndex } = useAccounts();
    const [showBarcode, setShowBarcode] = useState(false);
    const handleCarouselChange = (i) => setActiveAccountIndex(i);

    const handleBarcodeClick = (i) => {
        if (i !== activeAccountIndex) {
            return;
        }
        setShowBarcode(true);
    };

    if (!accounts) {
        return null;
    }

    /**
     * Every OAM user should have at least one account.
     * At this point, @accounts should only contain accounts that are not blocked.
     * If the length of @accounts is equal to zero then all accounts belonging to the user are blocked.
     * Render account suspended message
     */

    if (!accounts.length) {
        return <AccountSuspendedNotice />;
    }

    return (
        <div className="account-page">
            <FocusableHeader className="page-title">
                <FormattedMessage id="pages.account.title" />
            </FocusableHeader>
            <TransitionSlideIn className="digital-barcode-container" in={showBarcode}>
                <DigitalBarcode account={activeAccount} handleClose={() => setShowBarcode(false)} />
            </TransitionSlideIn>
            <DigitalCardCarousel
                accounts={accounts}
                activeAccountIndex={activeAccountIndex}
                afterChange={handleCarouselChange}
                onBarcodeClick={handleBarcodeClick}
            />
            <AccountSummary {...activeAccount} />
        </div>
    );
};

export default Account;
